import { ErrorResponse } from 'ts/types/ApiResponse'

type Props = {
  data: ErrorResponse
}

const Error = ({ data }: Props) => (
  <div className="self-end px-10 py-6 mb-4 text-sm text-white bg-red-600 rounded shadow-xl">
    <h2 className="font-bold">{data.title}</h2>
    {data.message}
  </div>
)

export default Error
